import { RelatedProduct } from 'models/RelatedProduct';
import { useConfigurator } from 'views/ProductPage/configurators/useConfigurator';
import { Reducer, useReducer, useEffect } from 'react';
import { Option, LabeledSelect } from 'components/Select';
import { rm } from 'utils';

interface OwnProps {
  products: RelatedProduct[];
  default: string | undefined;
  label: string;
}

interface OwnState {
  items: ProfileItem[];
}

interface ProfileItem {
  name: string;
  productId: string;
  selected: boolean;
  presentationPrice: number;
  currencyUnit: string;
}

export const profileMap: { [key: string]: string } = {
  Vit: 'white',
  Silver: 'silver',
  Brons: 'bronze',
  Sølv: 'silver',
  Hvit: 'white',
  Bronse: 'bronze',
  'Sanded Black': 'sand_black',
  'Sanded Grey': 'sand_grey',
  'Innocent Birch': 'innocent_birch',
  'Weathered Grey Oak': 'grey_oak'
};

const initialState: OwnState = {
  items: []
};

type OwnAction =
  | { type: 'selectItem'; productId: string }
  | { type: 'addProfiles'; products: RelatedProduct[]; default: string };

const ownReducer: Reducer<OwnState, OwnAction> = (state, action) => {
  switch (action.type) {
    case 'selectItem':
      return {
        ...state,
        items: state.items.map(i => ({ ...i, selected: i.productId === action.productId }))
      };
    case 'addProfiles':
      return {
        ...state,
        items: getItems(action.products, action.default)
      };
    default:
      return state;
  }
};

const getItems = (products: RelatedProduct[], defaultFilling: string) => {
  const items: ProfileItem[] = [];
  products.map(p => {
    items.push({
      name: p.title,
      productId: p.productId,
      selected: p.title === defaultFilling,
      presentationPrice: p.price.presentationPrice,
      currencyUnit: p.price.currencyUnit
    });
  });

  return items;
};

export default function ProfileAddons(props: OwnProps) {
  const [state, dispatch] = useReducer(ownReducer, initialState);
  const { onSelectChange } = useConfigurator();

  useEffect(() => {
    dispatch({
      type: 'addProfiles',
      products: props.products,
      default: props.default ? props.default : ''
    });
  }, [props.default, props.products]);

  const handleSelect = (val: string) => {
    const item = state.items.find(p => p.name === val);

    if (item) {
      const groupKey = 'profil';
      dispatch({ type: 'selectItem', productId: item.productId });
      onSelectChange(groupKey, item.name);
    }
  };

  const getSelectedValue = () => {
    const item = state.items.find(p => p.selected);

    return item ? item.name : undefined;
  };

  const selectedValue = getSelectedValue();

  return (
    <div>
      {state.items && (
        <LabeledSelect
          isSelected={!!selectedValue}
          label={props.label}
          placeHolder={rm('product_variant_choose')}
          onChange={handleSelect}
          selectedValue={selectedValue}
          scrollable
        >
          {state.items.map(p => (
            <Option key={p.productId} {...{ value: p.name, label: p.name }} />
          ))}
        </LabeledSelect>
      )}
    </div>
  );
}
